import { Button, MenuItem, Select, TextField } from "@mui/material";
import { FC } from "react";

interface Props {
  onChange: (values: any) => void;
  values: any;
}

const Filters: FC<Props> = ({ onChange, values }) => {
  return (
    <form
      className="flex gap-4 mb-4"
      onSubmit={(e) => {
        e.preventDefault();
        onChange(values);
      }}
    >
      <TextField
        type="date"
        value={values.start}
        onChange={(e) => onChange({ ...values, start: e.target.value })}
      />
      <TextField
        type="date"
        value={values.end}
        onChange={(e) => onChange({ ...values, end: e.target.value })}
      />
      <Select
        value={values.matched}
        onChange={(e) => onChange({ ...values, matched: e.target.value })}
        sx={{ width: "150px" }}
      >
        <MenuItem value="">Todas</MenuItem>
        <MenuItem value="false">Pendentes</MenuItem>
        <MenuItem value="true">Conciliadas</MenuItem>
      </Select>
      <Button type="submit" variant="contained">
        Filtrar
      </Button>
    </form>
  );
};

export default Filters;
